import i18n from "apps/visits/config/i18n";
import type { AxiosError } from "axios";
import { toast } from "react-hot-toast";
import {
  type DefaultOptions,
  QueryCache,
  QueryClient,
  type UseMutationOptions,
  type UseQueryOptions,
} from "react-query";
import type { PromiseValue } from "type-fest";

const queryConfig: DefaultOptions = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry: false,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
  queryCache: new QueryCache({
    onError: (_error, query) => {
      if (query.state.data !== undefined) {
        toast.error(i18n.t("COMMONS.ERRORS.GENERAL_REFRESH_API_ERROR"));
      }
    },
  }),
});

export type ExtractFnReturnType<FnType extends (...args: any) => any> = PromiseValue<ReturnType<FnType>>;

export type QueryConfig<QueryFnType extends (...args: any) => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  "queryKey" | "queryFn"
>;

export type MutationConfig<
  MutationFnType extends (...args: any) => any,
  Error extends AxiosError = AxiosError,
> = UseMutationOptions<ExtractFnReturnType<MutationFnType>, Error, Parameters<MutationFnType>[0]>;
